
export default function useAutoChange(value, setValue) {
  return (event) => {
    setValue({...value, [event.target.id]: event.target.value});
  }
}